import { WORKFLOW_TEMPLATE_PROMPTS } from "../../../constants/workflowTemplatePrompts";
import { getCurrentTime } from "../../../utils/getCurrentTime";
import { send_request } from "../../../utils/Request";

const hasValue = (value) =>
  value !== undefined && value !== null && value !== "";

export function createDraftWorkflowCard({ parentFolderId } = {}) {
  const card = {
    status: "DRAFT",
    lastModified: getCurrentTime(),
  };

  if (hasValue(parentFolderId)) {
    card.parentFolderId = parentFolderId;
  }

  return card;
}

export function submitDraftWorkflow(cardData) {
  return send_request("project-service/project/create", cardData, "", "post");
}

export function isWorkflowLimitError(errorOrResponse) {
  const candidates = [
    errorOrResponse?.toString?.(),
    errorOrResponse?.response?.status,
    errorOrResponse?.status,
    errorOrResponse?.response?.data?.message,
    errorOrResponse?.data?.message,
  ];

  return candidates.some((value) => String(value || "").includes("403"));
}

export function buildWorkflowCanvasPath(projectId) {
  return `/project/canvas/${projectId}`;
}

export function buildWorkflowTemplateCanvasLocation(
  projectId,
  { prompt, templateId } = {}
) {
  return {
    path: buildWorkflowCanvasPath(projectId),
    options: {
      state: {
        openWorkflowOperator: true,
        workflowTemplatePrompt: prompt,
        workflowTemplateId: templateId || null,
      },
    },
  };
}

export function resolveWorkflowTemplateLaunchFromLocation(location) {
  const state = location?.state || {};
  const prompt = String(state.workflowTemplatePrompt || "").trim();
  const templateId = state.workflowTemplateId || null;
  const openWorkflowOperator = state.openWorkflowOperator === true;

  if (!prompt && !openWorkflowOperator) {
    return {
      prompt: "",
      templateId: null,
      openWorkflowOperator: false,
    };
  }

  return {
    prompt,
    templateId,
    openWorkflowOperator,
  };
}

export function resolveWorkflowTemplatePromptFromLocation(location) {
  const { prompt, templateId } =
    resolveWorkflowTemplateLaunchFromLocation(location);
  return { prompt, templateId };
}

export function getOrderedWorkflowTemplates(
  templates = WORKFLOW_TEMPLATE_PROMPTS
) {
  return [...templates].sort((a, b) => {
    if (a.featured === b.featured) {
      return a.title.localeCompare(b.title);
    }
    return a.featured ? -1 : 1;
  });
}
